export default {
  recommendedShopsTitle: {
    gb: 'Browse Top Shops in the UK',
    default: 'Browse Top Shops',
  },
};
